export const SCOPE_SMALL_SET = 'SCOPE_SMALL_SET';
export const SCOPE_FULL_SET = 'SCOPE_FULL_SET';

export const AUTHORIZATION_REQUEST_LOGIN = 'AUTHORIZATION_REQUEST_LOGIN';
export const AUTHORIZATION_RECEIVE_LOGIN = 'AUTHORIZATION_RECEIVE_LOGIN';
export const AUTHORIZATION_RECEIVE_LOGIN_ERROR = 'AUTHORIZATION_RECEIVE_LOGIN_ERROR';
export const AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR = 'AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR';
export const AUTHORIZATION_LOGOUT = 'AUTHORIZATION_LOGOUT';
export const AUTHORIZATION_CHANGE_USERNAME = 'AUTHORIZATION_CHANGE_USERNAME';

export const TRANSLATION_RECEIVE_TRANSLATIONS = 'TRANSLATION_RECEIVE_TRANSLATIONS';
export const TRANSLATION_FILTER_BY_SEARCH_STRING = 'TRANSLATION_FILTER_BY_SEARCH_STRING';
export const TRANSLATION_DIALOG_ADD_TRANSLATION = 'TRANSLATION_DIALOG_ADD_TRANSLATION';
export const TRANSLATION_DIALOG_EDIT_TRANSLATION = 'TRANSLATION_DIALOG_EDIT_TRANSLATION';
export const TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION = 'TRANSLATION_CANCEL_ADD_EDIT_TRANSLATION';
export const TRANSLATION_SEND_ADD_EDIT_TRANSLATION = 'TRANSLATION_SEND_ADD_EDIT_TRANSLATION';
export const TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION = 'TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION';
export const TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR = 'TRANSLATION_RECEIVE_ADD_EDIT_TRANSLATION_ERROR';
export const TRANSLATION_RECEIVE_DELETE_TRANSLATION = 'TRANSLATION_RECEIVE_DELETE_TRANSLATION';

export const SUPPORTER_LIST_RECEIVE_SUPPORTERS = 'SUPPORTER_RECEIVE_SUPPORTERS';
export const SUPPORTER_LIST_PAGINATE = 'SUPPORTER_LIST_PAGINATE';
export const SUPPORTER_LIST_SEARCH_STRING_CHANGE = 'SUPPORTER_LIST_SEARCH_STRING_CHANGE';
export const SUPPORTER_LIST_PERIODS_FILTER_CHANGE = 'SUPPORTER_LIST_PERIODS_FILTER_CHANGE';
export const SUPPORTER_LIST_STATES_FILTER_CHANGE = 'SUPPORTER_LIST_STATES_FILTER_CHANGE';

export const SUPPORTER_DETAILS_REQUEST_SUPPORTER = 'SUPPORTER_DETAILS_REQUEST_SUPPORTER';
export const SUPPORTER_DETAILS_RECEIVE_SUPPORTER = 'SUPPORTER_DETAILS_RECEIVE_SUPPORTER';
export const SUPPORTER_DETAILS_CHANGE_VALUE = 'SUPPORTER_DETAILS_CHANGE_VALUE';
export const SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE = 'SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE';
export const SUPPORTER_DETAILS_SEND_SAVE = 'SUPPORTER_DETAILS_SEND_SAVE';
export const SUPPORTER_DETAILS_RECEIVE_SAVE = 'SUPPORTER_DETAILS_RECEIVE_SAVE';
export const SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR = 'SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR';
export const SUPPORTER_DETAILS_EDIT = 'SUPPORTER_DETAILS_EDIT';

export const SUPPORTER_PROJECT_REQUEST_DATA = 'SUPPORTER_PROJECT_REQUEST_DATA';
export const SUPPORTER_PROJECT_RECEIVE_DATA = 'SUPPORTER_PROJECT_RECEIVE_DATA';
export const SUPPORTER_PROJECT_RECEIVE_NOT_FOUND = 'SUPPORTER_PROJECT_RECEIVE_NOT_FOUND';
export const SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE = 'SUPPORTER_PROJECT_TOGGLE_BOOLEAN_VALUE';
export const SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE = 'SUPPORTER_PROJECT_TOGGLE_ITEM_VALUE';
export const SUPPORTER_PROJECT_SET_ITEM_VALUE = 'SUPPORTER_PROJECT_SET_ITEM_VALUE';
export const SUPPORTER_PROJECT_CHANGE_VALUE = 'SUPPORTER_PROJECT_CHANGE_VALUE';
export const SUPPORTER_PROJECT_SEND_SAVE = 'SUPPORTER_PROJECT_SEND_SAVE';
export const SUPPORTER_PROJECT_RECEIVE_SAVE = 'SUPPORTER_PROJECT_RECEIVE_SAVE';
export const SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR = 'SUPPORTER_PROJECT_RECEIVE_SAVE_ERROR';
export const SUPPORTER_PROJECT_EDIT = 'SUPPORTER_PROJECT_EDIT';

export const SUPPORTER_EMERGENCY_CONTACT_REQUEST = 'SUPPORTER_EMERGENCY_CONTACT_REQUEST';
export const SUPPORTER_EMERGENCY_CONTACT_RECEIVE = 'SUPPORTER_EMERGENCY_CONTACT_RECEIVE';
export const SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE = 'SUPPORTER_EMERGENCY_CONTACT_CHANGE_VALUE';
export const SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE = 'SUPPORTER_EMERGENCY_CONTACT_SEND_SAVE';
export const SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE = 'SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE';
export const SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR = 'SUPPORTER_EMERGENCY_CONTACT_RECEIVE_SAVE_ERROR';
export const SUPPORTER_EMERGENCY_CONTACT_EDIT = 'SUPPORTER_EMERGENCY_CONTACT_EDIT';

export const PROFILE_USER_REQUEST = 'PROFILE_USER_REQUEST';
export const PROFILE_USER_RECEIVE = 'PROFILE_USER_RECEIVE';
export const PROFILE_USER_CHANGE_VALUE = 'PROFILE_USER_CHANGE_VALUE';
export const PROFILE_USER_SEND_SAVE = 'PROFILE_USER_SEND_SAVE';
export const PROFILE_USER_RECEIVE_SAVE = 'PROFILE_USER_RECEIVE_SEND';
export const PROFILE_USER_RECEIVE_SAVE_ERROR = 'PROFILE_USER_RECEIVE_SEND_ERROR';
export const PROFILE_USER_EDIT = 'PROFILE_USER_EDIT';

export const QUEUE_LIST_REQUEST_QUEUES = 'QUEUE_LIST_REQUEST_QUEUES';
export const QUEUE_LIST_RECEIVE_QUEUES = 'QUEUE_LIST_RECEIVE_QUEUES';
export const QUEUE_LIST_FILTER = 'QUEUE_LIST_FILTER';
export const QUEUE_LIST_FILTER_BY_CURRENT_PERIOD = 'QUEUE_LIST_FILTER_BY_CURRENT_PERIOD';
export const QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE = 'QUEUE_LIST_TOGGLE_QUEUE_COLLAPSE';

export const OVERVIEW_PROJECT_OVERVIEW_REQUEST = 'OVERVIEW_PROJECT_OVERVIEW_REQUEST';
export const OVERVIEW_PROJECT_OVERVIEW_RECEIVE = 'OVERVIEW_PROJECT_OVERVIEW_RECEIVE';
export const OVERVIEW_CAMPING_STATS_REQUEST = 'OVERVIEW_CAMPING_STATS_REQUEST';
export const OVERVIEW_CAMPING_STATS_RECEIVE = 'OVERVIEW_CAMPING_STATS_RECEIVE';

export const SUPPORTER_COMMENTS_REQUEST = 'SUPPORTER_COMMENTS_REQUEST';
export const SUPPORTER_COMMENTS_RECEIVE = 'SUPPORTER_COMMENTS_RECEIVE';
export const SUPPORTER_COMMENTS_ADD = 'SUPPORTER_COMMENTS_ADD';
export const SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE = 'SUPPORTER_COMMENTS_ADD_EDIT_TEXT_CHANGE';
export const SUPPORTER_COMMENTS_ADD_SEND = 'SUPPORTER_COMMENTS_ADD_SEND';
export const SUPPORTER_COMMENTS_ADD_RECEIVE = 'SUPPORTER_COMMENTS_ADD_RECEIVE';
export const SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR = 'SUPPORTER_COMMENTS_ADD_RECEIVE_ERROR';
export const SUPPORTER_COMMENTS_UNDO_ADD_EDIT = 'SUPPORTER_COMMENTS_UNDO_ADD_EDIT';
export const SUPPORTER_COMMENTS_DELETE_REQUEST = 'SUPPORTER_COMMENTS_DELETE_REQUEST';
export const SUPPORTER_COMMENTS_TOGGLE_BOOKMARK = 'SUPPORTER_COMMENTS_TOGGLE_BOOKMARK';

export const SCHEDULE_GET_REQUEST = 'SCHEDULE_GET_REQUEST';
export const SCHEDULE_GET_RECEIVE = 'SCHEDULE_GET_RECEIVE';

export const ADD_LOCATION_OPEN = 'ADD_LOCATION_OPEN';
export const ADD_LOCATION_PREPARE_REQUEST = 'ADD_LOCATION_PREPARE_REQUEST';
export const ADD_LOCATION_PREPARE_RECEIVE = 'ADD_LOCATION_PREPARE_RECEIVE';
export const ADD_LOCATION_SAVE_REQUEST = 'ADD_LOCATION_SAVE_REQUEST';
export const ADD_LOCATION_SAVE_RECEIVE = 'ADD_LOCATION_SAVE_RECEIVE';
export const ADD_LOCATION_SAVE_RECEIVE_ERROR = 'ADD_LOCATION_SAVE_RECEIVE_ERROR';
export const ADD_LOCATION_CANCEL = 'ADD_LOCATION_CANCEL';
export const ADD_LOCATION_CHANGE_VALUE = 'ADD_LOCATION_CHANGE_VALUE';

export const APP_DIALOG_SHIFT_DETAILS_OPEN = 'APP_DIALOG_SHIFT_DETAILS_OPEN';
export const APP_DIALOG_SHIFT_DETAILS_CLOSE = 'APP_DIALOG_SHIFT_DETAILS_CLOSE';

export const APP_DIALOG_ADD_SHIFT_OPEN = 'APP_DIALOG_ADD_SHIFT_OPEN';
export const APP_DIALOG_ADD_SHIFT_CLOSE = 'APP_DIALOG_ADD_SHIFT_CLOSE';

export const CASH_REGISTER_TICKET_REQUEST = 'CASH_REGISTER_TICKET_REQUEST';
export const CASH_REGISTER_TICKET_RECEIVE = 'CASH_REGISTER_TICKET_RECEIVE';
export const CASH_REGISTER_TICKET_RECEIVE_ERROR = 'CASH_REGISTER_TICKET_RECEIVE_ERROR';
export const CASH_REGISTER_OPEN_CR_REQUEST = 'CASH_REGISTER_OPEN_CR_REQUEST';
export const CASH_REGISTER_OPEN_CR_RECEIVE = 'CASH_REGISTER_OPEN_CR_RECEIVE';
export const CASH_REGISTER_OPEN_CR_RECEIVE_ERROR = 'CASH_REGISTER_OPEN_CR_RECEIVE_ERROR';
export const CASH_REGISTER_OPEN_REQUEST = 'CASH_REGISTER_OPEN_REQUEST';
export const CASH_REGISTER_OPEN_RECEIVE = 'CASH_REGISTER_OPEN_RECEIVE';
export const CASH_REGISTER_OPEN_RECEIVE_ERROR = 'CASH_REGISTER_OPEN_RECEIVE_ERROR';
export const CASH_REGISTER_REQUEST = 'CASH_REGISTER_REQUEST';
export const CASH_REGISTER_RECEIVE = 'CASH_REGISTER_RECEIVE';
export const CASH_REGISTER_RECEIVE_ERROR = 'CASH_REGISTER_RECEIVE_ERROR';
export const CASH_REGISTER_ADD_ACCOUNTING_REQUEST = 'CASH_REGISTER_ADD_ACCOUNTING_REQUEST';
export const CASH_REGISTER_ADD_ACCOUNTING_RECEIVE = 'CASH_REGISTER_ADD_ACCOUNTING_RECEIVE';
export const CASH_REGISTER_ADD_ACCOUNTING_RECEIVE_ERROR = 'CASH_REGISTER_ADD_ACCOUNTING_RECEIVE_ERROR';
export const CASH_REGISTER_CHECK_IN_REQUEST = 'CASH_REGISTER_CHECK_IN_REQUEST';
export const CASH_REGISTER_CHECK_IN_RECEIVE = 'CASH_REGISTER_CHECK_IN_RECEIVE';
export const CASH_REGISTER_CHECK_IN_RECEIVE_ERROR = 'CASH_REGISTER_CHECK_IN_RECEIVE_ERROR';
export const CASH_REGISTER_LEAVE_CURRENT = 'CASH_REGISTER_LEAVE_CURRENT';
export const CASH_REGISTER_CLOSE_REQUEST = 'CASH_REGISTER_CLOSE_REQUEST';
export const CASH_REGISTER_CLOSE_RECEIVE = 'CASH_REGISTER_CLOSE_RECEIVE';
export const CASH_REGISTER_CLOSE_RECEIVE_ERROR = 'CASH_REGISTER_CLOSE_RECEIVE_ERROR';
export const CASH_REGISTER_CLOSED_CR_REQUEST = 'CASH_REGISTER_CLOSED_CR_REQUEST';
export const CASH_REGISTER_CLOSED_CR_RECEIVE = 'CASH_REGISTER_CLOSED_CR_RECEIVE';
export const CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR = 'CASH_REGISTER_CLOSED_CR_RECEIVE_ERROR';
export const CASH_REGISTER_CLOSE_TICKET = 'CASH_REGISTER_CLOSE_TICKET';
export const CASH_REGISTER_CHECK_OUT_REQUEST = 'CASH_REGISTER_CHECK_OUT_REQUEST';
export const CASH_REGISTER_CHECK_OUT_RECEIVE_ERROR = 'CASH_REGISTER_CHECK_OUT_RECEIVE_ERROR';
export const CASH_REGISTER_CHECK_OUT_RECEIVE = 'CASH_REGISTER_CHECK_OUT_RECEIVE';

export const TABLET_START_SYNC = 'TABLET_START_SYNC';
export const TABLET_RECEIVE_SYNC = 'TABLET_RECEIVE_SYNC';
export const TABLET_RECEIVE_SYNC_ERROR = 'TABLET_RECEIVE_SYNC_ERROR';
export const TABLET_SET_TIME_SLOT = 'TABLET_SET_TIME_SLOT';
export const TABLET_SET_ROUTE = 'TABLET_SET_ROUTE';
export const TABLET_SET_SUPPORTER_AVAILABLE = 'TABLET_SET_SUPPORTER_AVAILABLE';
export const TABLET_CHECK_IN_SUPPORTER = 'TABLET_CHECK_IN_SUPPORTER';
export const TABLET_ADD_SUPPORTER_TO_SHIFT = 'TABLET_ADD_SUPPORTER_TO_SHIFT';

export const PROJECT_RECEIVE_AVAILABLE_PROJECTS = 'PROJECT_RECEIVE_AVAILABLE_PROJECTS';
export const PROJECT_SELECT_PROJECT = 'PROJECT_SELECT_PROJECT';

export const LOGBOOK_LOAD_REQUEST = 'LOGBOOK_LOAD_REQUEST';
export const LOGBOOK_LOAD_SUCCESS = 'LOGBOOK_LOAD_SUCCESS';
export const LOGBOOK_LOAD_SUCCESS_NO_DATA = 'LOGBOOK_LOAD_SUCCESS_NO_DATA';
export const LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST = 'LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST';
export const LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS = 'LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS';

export const PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS = 'PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS';
export const PRINTER_SET_PRINTER = 'PRINTER_SET_PRINTER';

export const COMPANIES_LOAD_SUCCESS = 'COMPANIES_LOAD_SUCCESS';
export const COMPANIES_UPDATED = 'COMPANIES_UPDATED';
